var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / TO") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DF101B",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C00711",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-TO",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("rect", {
    stroke: "#F5F5F5",
    strokeWidth: 0.5,
    x: 0.25,
    y: 0.25,
    width: 27.5,
    height: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,10.6666667 L16,0 L28,0 L28,20 L0,20 L0,10.6666667 L16,10.6666667 Z",
    id: "Combined-Shape",
    fill: "#E20F1B",
    mask: "url(#mask-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00634766,1.33333333 C9.18693686,1.33333333 9.33333333,1.48600038 9.33333333,1.65685113 L9.333,3.99933333 L11.6764822,4 C11.8551561,4 12,4.14337158 12,4.32698568 L12,6.33968099 C12,6.52027019 11.847333,6.66666667 11.6764822,6.66666667 L9.333,6.66633333 L9.33333333,9.00981553 C9.33333333,9.18848948 9.18996175,9.33333333 9.00634766,9.33333333 L6.99365234,9.33333333 C6.81306314,9.33333333 6.66666667,9.18066629 6.66666667,9.00981553 L6.666,6.66633333 L4.3235178,6.66666667 C4.14484385,6.66666667 4,6.52329508 4,6.33968099 L4,4.32698568 C4,4.14639647 4.15266705,4 4.3235178,4 L6.666,3.99933333 L6.66666667,1.65685113 C6.66666667,1.47817719 6.81003825,1.33333333 6.99365234,1.33333333 L9.00634766,1.33333333 Z",
    id: "Rectangle-1703",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTo);
export default __webpack_public_path__ + "static/media/TO.d799b212125ba95d8e6ed767f5cf384b.svg";
export { ForwardRef as ReactComponent };